import * as React from "react";
import { CollapseActions } from "./state/actions";

export interface ICollapseContext {
  state: Set<string>;
  dispatch: React.Dispatch<CollapseActions>;
}

export const CollapseContext = React.createContext<ICollapseContext>({
  state: new Set<string>(),
  dispatch: () => {
    // eslint-disable-next-line no-console
    console.error("Component not wrapped in CollapseContext");
  }
});

export const useCollapseContext = () => React.useContext(CollapseContext);
